import formatNumber from './formatNumber';

export const calculateTipToPay = (baseToPay: number, selectedTipPercentage: number) => {
  return Number(formatNumber((baseToPay * selectedTipPercentage) / 100));
};
